<ion-header>
    <ion-toolbar color="gallaghergreen">
      <img (click)="navigateToBaseLogin()" class="gallagher-logo" [src]="'./assets/images/Gallagher Logo -White Transparent.png'" />
    </ion-toolbar>
</ion-header>
  
<ion-content class="login-content">
  <div class="parent-container">
    <ion-card [ngClass]="{'larger-width': authService.isNative}">
        <ion-card-header>
            <div>
                <span class="login-title">Reset Password</span>
            </div>
        </ion-card-header>
        <ion-grid>
          <div>
            <ion-row>
              <ion-col>
                <ion-label>New Password *</ion-label>
                <app-show-hide-password>
                    <ion-input type="password" autocomplete="password" autocapitalize="none" [(ngModel)]="password" placeholder="Enter the password"  class="ion-text-left color-light user-id"></ion-input>
                </app-show-hide-password>
              </ion-col>
            </ion-row>
          </div>

          <div>
            <ion-row>
              <ion-col>
                <ion-label>Re-enter New Password *</ion-label>
                <app-show-hide-password>
                    <ion-input type="password" autocomplete="password" autocapitalize="none" [(ngModel)]="reenterPassword" placeholder="Re-enter the password"  class="ion-text-left color-light user-id"></ion-input>
                </app-show-hide-password>
              </ion-col>
            </ion-row>
          </div>

          <ion-row>
            <ion-col>
                <ion-button color="gallaghergreen" class="btn-box-shadow submit-button" [disabled]="!reenterPassword || !password" (click)="submit()">Submit</ion-button>
            </ion-col>
          </ion-row>

        </ion-grid>
      </ion-card>
  </div>
</ion-content>